import { PropsWithChildren } from 'react'

interface IProps extends PropsWithChildren {
  condition?: boolean
}

export const RenderWhen = ({ condition, children }: IProps) => {
  if (condition) {
    return <>{children}</>
  }
  return null
}
